webpackJsonp([454],{

/***/ 1193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.0.0 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2147:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1193),
  /* template */
  __webpack_require__(2861),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/v2.0.0-72.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.0.0-72.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-72743120", Component.options)
  } else {
    hotAPI.reload("data-v-72743120", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2861:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.0.0 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/actionsheet.html"
    }
  }, [_vm._v("Actionsheet")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] upgrade to vue@2.0, use `v-model` instead of `:show.sync`")]), _vm._v(" "), _c('li', [_vm._v("[feature] add prop close-on-clicking-mask")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] use `v-model` instead of `:show.sync`")]), _vm._v(" "), _c('li', [_vm._v("[todo] fix animation")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/button-tab.html"
    }
  }, [_vm._v("ButtonTab")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] remove tap highlight")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checker.html"
    }
  }, [_vm._v("Checker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support Object value #705")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checklist.html"
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] it does not show errors by default, handle errors by on-error events")]), _vm._v(" "), _c('li', [_vm._v("[feature] add slot:footer slot:after-title")]), _vm._v(" "), _c('li', [_vm._v("[change] if value.length === max, the left items will be disabled")]), _vm._v(" "), _c('li', [_vm._v("[change] default required value is false")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/color-picker.html"
    }
  }, [_vm._v("ColorPicker")])]), _vm._v(" "), _c('ul'), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/countdown.html"
    }
  }, [_vm._v("Countdown")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[deprecated] This component is no longer maintained")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/countup.html"
    }
  }, [_vm._v("Countup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add prop:start")]), _vm._v(" "), _c('li', [_vm._v("[change] Update countup -> countup.js")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/form-preview.html"
    }
  }, [_vm._v("FormPreview")])]), _vm._v(" "), _c('ul'), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/load-more.html"
    }
  }, [_vm._v("LoadMore")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Add `load-more` component")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popover.html"
    }
  }, [_vm._v("Popover")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[todo] wrong position if changing locale")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/toast.html"
    }
  }, [_vm._v("Toast")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] use `v-model` instead of `:show.sync`")]), _vm._v(" "), _c('li', [_vm._v("[change] do not show mask by default")]), _vm._v(" "), _c('li', [_vm._v("[feature] add prop:isShowMask")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul'), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-number.html"
    }
  }, [_vm._v("XNumber")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] set `fiilable` default value to `false`")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72743120", module.exports)
  }
}

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2147);

/***/ })

});


// WEBPACK FOOTER //
// 454.5931b9f1.js